import { Stack } from '@mui/material';
import { NextPrevButton } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

interface IButtons {
  resetAndExit: () => void;
  onSubmit: () => void;
  isEdit: boolean;
}

export const Buttons = ({ resetAndExit, onSubmit, isEdit }: IButtons) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements).form;
  const isDesktop = useIsDesktop();

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        mt: 4,
        justifyContent: 'center',
        gap: '48px',
      }}
    >
      <NextPrevButton
        callback={resetAndExit}
        text={dictionary.exit}
        style={
          isDesktop
            ? undefined
            : {
                button: {
                  height: '36px',
                  width: isDesktop ? '244px' : '120px',
                },
                text: {
                  fontSize: '16px',
                  fontWeight: isDesktop ? '600' : '700',
                },
              }
        }
      />
      <NextPrevButton
        callback={() => {
          onSubmit();
        }}
        text={isEdit ? dictionary.editSave : dictionary.save}
        style={
          isDesktop
            ? undefined
            : {
                button: {
                  height: '36px',
                  width: isDesktop ? '244px' : '187px',
                },
                text: {
                  fontSize: '16px',
                  fontWeight: isDesktop ? '600' : '700',
                },
              }
        }
        isBlue
        isNext
      />
    </Stack>
  );
};
